import React from 'react';
import styles from './Faq.module.scss';

const Faq = ({ faqs = [], destinationName }) => {
  if (faqs.length === 0) return null;

  return (
    <section id="faqs" className={styles.section}>
      <div className={styles.kicker}>Good to Know</div>
      <h2 className={styles.heading}>Frequently Asked Questions</h2>
      <p className={styles.lede}>
        The most common questions from first-time and returning{' '}
        {destinationName ? `${destinationName} ` : ''}visitors — answered
        honestly.
      </p>

      <div className={styles.list}>
        {faqs.map((faq) => (
          <details key={faq._id} className={styles.item}>
            <summary className={styles.question}>
              <span>{faq.question}</span>
              <span className={styles.icon} aria-hidden="true" />
            </summary>
            <div
              className={`${styles.answer} inserted-html`}
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </details>
        ))}
      </div>
    </section>
  );
};

export default Faq;
